// resources/js/modules/GvDragCarousel.js

export default class GVDragCarousel {
    constructor(options) {
        const resolve = (ref) => (typeof ref === 'string' ? document.querySelector(ref) : ref) || null;

        this.wrapper = resolve(options.wrapper);
        if (!this.wrapper) return;

        this.leftArrow = resolve(options.leftArrow);
        this.rightArrow = resolve(options.rightArrow);
        this.dragSpeed = options.dragSpeed || 1.5;

        this.isDragActive = false;
        this.startDragX = 0;
        this.initialScrollLeft = 0;

        this.init();
    }

    init() {
        this.wrapper.addEventListener("mousedown", (e) => this.onDragStart(e));
        this.wrapper.addEventListener("mousemove", (e) => this.onDragMove(e));
        this.wrapper.addEventListener("mouseup", () => this.onDragEnd());
        this.wrapper.addEventListener("mouseleave", () => this.onDragEnd());

        if (this.leftArrow && this.rightArrow) {
            this.leftArrow.addEventListener("click", () => this.scrollLeft());
            this.rightArrow.addEventListener("click", () => this.scrollRight());
            this.wrapper.addEventListener("scroll", () => this.updateNavigation());
            window.addEventListener("resize", () => this.updateNavigation());

            setTimeout(() => this.updateNavigation(), 300);
        }
    }

    onDragStart(e) {
        this.isDragActive = true;
        this.wrapper.style.scrollBehavior = "auto";
        this.startDragX = e.pageX - this.wrapper.offsetLeft;
        this.initialScrollLeft = this.wrapper.scrollLeft;
        this.wrapper.style.cursor = "grabbing";
    }

    onDragMove(e) {
        if (!this.isDragActive) return;
        e.preventDefault();
        const x = e.pageX - this.wrapper.offsetLeft;
        const walk = (x - this.startDragX) * this.dragSpeed;
        this.wrapper.scrollLeft = this.initialScrollLeft - walk;
    }

    onDragEnd() {
        this.isDragActive = false;
        this.wrapper.style.scrollBehavior = "smooth";
        this.wrapper.style.cursor = "grab";
    }

    getOffset() {
        const firstCard = this.wrapper.firstElementChild?.firstElementChild;
        return firstCard ? firstCard.offsetWidth + 16 : 280;
    }

    scrollLeft() {
        this.wrapper.style.scrollBehavior = "smooth";
        this.wrapper.scrollLeft -= this.getOffset();
    }

    scrollRight() {
        this.wrapper.style.scrollBehavior = "smooth";
        this.wrapper.scrollLeft += this.getOffset();
    }

    updateNavigation() {
        const scrollLeftVal = this.wrapper.scrollLeft;
        const maxScrollVal = this.wrapper.scrollWidth - this.wrapper.clientWidth;

        if (scrollLeftVal <= 5) {
            this.leftArrow.classList.add("disabled");
        } else {
            this.leftArrow.classList.remove("disabled");
        }

        if (scrollLeftVal >= maxScrollVal - 5) {
            this.rightArrow.classList.add("disabled");
        } else {
            this.rightArrow.classList.remove("disabled");
        }
    }
}
